/**
 * Selects and focuses the targettedTab.
 * @param   {Object}   targettedTab    the tab to select and focus.
 * @param   {NodeList} listOfTabs      the NodeList containing targettedTab.
 * @param   {NodeList} listOfTabPanels the NodeList of tab panels corresponding
 * to the tabs in listOfTabs.
 */
const selectTab = (targettedTab, listOfTabs, listOfTabPanels) => {
  // Unhighlight all tabs
  listOfTabs.forEach((tab) => {
    tab.setAttribute('aria-selected', 'false');
    tab.setAttribute('tabindex', '-1');
    tab.classList.remove('is-selected-tab');
  });

  // Hightlight selected tab
  targettedTab.setAttribute('aria-selected', 'true');
  targettedTab.setAttribute('tabindex', '0');

  const targettedTabRichText = targettedTab.querySelector('.rich-text');

  if (targettedTabRichText) {
    targettedTabRichText.focus();
  } else {
    targettedTab.focus();
  }

  targettedTab.classList.add('is-selected-tab');

  // Hide all tab panels
  listOfTabPanels.forEach((tabPanel) => {
    tabPanel.setAttribute('aria-expanded', 'false');
    tabPanel.classList.remove('is-selected-tab');
  });

  // Show selected tab's tab-panel
  const selectedTabPanelId = targettedTab.getAttribute('aria-controls');
  const selectedTabPanel = document.getElementById(selectedTabPanelId);
  selectedTabPanel.setAttribute('aria-expanded', 'true');
  selectedTabPanel.classList.add('is-selected-tab');
};

export default selectTab;
